export const pipelineEntityTypes = [
    "ReferenceContact",
    "ReferenceBusiness",
    "Community",
];
export const stageTransitionEntityTypes = [
    ...pipelineEntityTypes,
    "Placement",
    "HomeCareLead",
];
export const pipelineCardSorts = [
    "updatedAtDesc",
    "updatedAtAsc",
    "createdAtDesc",
    "createdAtAsc",
    "nameAsc",
    "nameDesc",
];
//# sourceMappingURL=pipeline.js.map